import { Typography } from "@coolset/cs-ui";
import { Switch, TextField } from "@mui/material";
import { BlockFieldTypes, ExportInstructions } from "modules/MainSurveyEditor/helpers/blockForm";
import { useCallback} from "react";
import { FormInput } from "shared/components/Inputs/FormInput";

export const ExportInstructionsSection = (props: ExportInstructionsSectionProps) => {
  const { isExportable = false, exportInstructions = { name: "" }, handleFieldChange } = props;

  const { name = "", helperText = "" } = exportInstructions;

  const handleExportInstructionsChange = useCallback(
    (name: string, helperText?: string) => {
      handleFieldChange(BlockFieldTypes.ExportInstructions, { name, helperText });

      if (!name) {
        handleFieldChange(BlockFieldTypes.IsExportable, false);
      }
    },
    [handleFieldChange]
  );

  return (
    <>
      <Typography variant="h4">Export</Typography>
      <FormInput
        title="Allow users to export"
        isOptional={false}
        fieldInput={
          <Switch
            className="module-field-switch"
            disabled={!name}
            checked={isExportable}
            onChange={(e) => handleFieldChange(BlockFieldTypes.IsExportable, e.target.checked)}
          />
        }
        tooltipTitle="In order to allow users to export the survey, you need to provide a name for the export."
      />
      <FormInput
        title="Name"
        isOptional={false}
        fieldInput={
          <TextField
            fullWidth
            onChange={(e) => handleExportInstructionsChange(e.target.value, helperText)}
            value={name}
          />
        }
      />
      <FormInput
        title="Helper text"
        isOptional={true}
        fieldInput={
          <TextField
            fullWidth
            onChange={(e) => handleExportInstructionsChange(name, e.target.value)}
            value={helperText}
          />
        }
      />
    </>
  );
};

interface ExportInstructionsSectionProps {
  isExportable?: boolean;
  exportInstructions?: ExportInstructions;
  handleFieldChange: (field: string, value: any) => void;
}
